import React from 'react';

export default function UpcomingSection({ events, formatDate, getTypeColor, getTypeLabel }) {
  if (events.length === 0) {
    return (
      <div className="card text-center py-4 sm:py-6 text-on-surface-variant">
        <span className="text-xl sm:text-2xl mr-2">📅</span> <span className="text-sm sm:text-base">No upcoming items in the next 30 days</span>
      </div>
    );
  }

  const daysUntil = (dateStr) => {
    const today = new Date();
    const dueDate = new Date(dateStr);
    const diff = Math.floor((dueDate - today) / (1000 * 60 * 60 * 24));
    return diff;
  };

  // Group by week
  const groupedByWeek = {
    thisWeek: [],
    nextWeek: [],
    later: [],
  };

  events.forEach((event) => {
    const days = daysUntil(event.date);
    if (days < 7) groupedByWeek.thisWeek.push(event);
    else if (days < 14) groupedByWeek.nextWeek.push(event);
    else groupedByWeek.later.push(event);
  });

  const renderWeekGroup = (title, items, highlight = false) => {
    if (items.length === 0) return null;
    return (
      <div key={title} className="space-y-2">
        <h4
          className={`text-sm sm:text-base font-bold font-headline ${highlight ? 'text-secondary' : 'text-on-surface-variant'}`}
        >
          {title} ({items.length})
        </h4>
        {items.map((event) => (
          <div key={event.id} className={`card p-2 sm:p-3 ${highlight ? 'bg-secondary-fixed' : ''}`}>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
              <div className="flex-1 min-w-0">
                <p className="font-medium text-sm sm:text-base truncate">{event.title}</p>
                <p className="text-xs text-on-surface-variant">
                  {formatDate(event.date)} • {getTypeLabel(event.type)}
                </p>
              </div>
              <span className={`badge text-xs ml-0 sm:ml-2 whitespace-nowrap ${getTypeColor(event.type)}`}>
                {event.type}
              </span>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      {renderWeekGroup('Due This Week', groupedByWeek.thisWeek, true)}
      {renderWeekGroup('Next Week', groupedByWeek.nextWeek)}
      {renderWeekGroup('Later This Month', groupedByWeek.later)}
    </div>
  );
}
